import { Tooltip } from '@material-ui/core';
import styled from 'styled-components';
import { Flex } from '../base/layout-components';
import TooltipWrapper from '../Tooltips/TooltipWrapper';
import Text from '../base/Text';
import { resetTooltipStyle } from '../Tooltips/helpers';
import Icon from 'components/base/Icon';
import { LinkWithoutUnderline } from './ContributorsRosterByTeamHidePersonalInfo';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';

const ContentWrapper = styled(Flex)`
  border-radius: 0.5rem;
  flex-direction: row;
  ${({ backgroundColor }) =>
    backgroundColor ? `background-color: ${backgroundColor}` : ''};
`;

const TooltipContent = ({ name }) => {
  return (
    <TooltipWrapper>
      <Flex direction='column' align='center' padding='small'>
        <Flex items='center'>
          <Icon name='ErrorIcon' size='normal' color='orangePeel' />
          <Text pl='0.5rem' size='medium'>
            Looks like {name} has too much work
          </Text>
        </Flex>
      </Flex>
    </TooltipWrapper>
  );
};

const Wip = ({ isRetrospect, link, name, isTopReviewer, isBurnout }) => {
  const disableHover = isRetrospect;
  const showWipText = !isTopReviewer && !isBurnout;
  return (
    <Tooltip
      classes={resetTooltipStyle()}
      disableHoverListener={disableHover}
      title={<TooltipContent name={name} />}
    >
      <ContentWrapper direction='column'>
        <LinkWithoutUnderline
          to={link}
          onClick={() =>
            TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
              page: TRACKING.PAGES.DASHBOARD,
              click_type: TRACKING.CLICK.CONTRIBUTOR_BRANCHES
            })
          }
        >
          {!isRetrospect && (
            <Flex items='center'>
              {showWipText && (
                <Text
                  size='large'
                  weight={400}
                  data-testid='wip-text'
                  className='status-text'
                >
                  WIP overload
                </Text>
              )}
              <Icon name='ErrorIcon' size='large' color={'orangePeel'} />
            </Flex>
          )}
        </LinkWithoutUnderline>
      </ContentWrapper>
    </Tooltip>
  );
};

export default Wip;
